export default "__VITE_ASSET__44e21fc6__"